/**
 * Утилита для перезагрузки страницы
 * */
export var reloadPage = function reloadPage() {
  window.location.reload();
};